import axios from "axios";
import { dispatch } from "d3";
import * as MODULES from "../module-codes";

export const state = {
  text: '',
}

export const getters = {
  text: state => state.text,
}

export const actions = {
  updateNotes: ({ commit, state, dispatch }, payload) => {
    commit("UPDATE_NOTES", payload)
    dispatch('updateModuleInDB')
  },

  updateModuleInDB: async ({ state, rootState }) => {
    await axios.post("/api/updateModule", {
      params: {
        moduleState: {text: state.text},
        moduleName: MODULES.NOTES,
        pcs: localStorage.getItem('pcs'),
        classId: rootState.auth.classId,
      },
    })
  },
  populateNotesFromDB: async ({ commit }) => {
    axios.post('/api/pcs/notes', {
      params: {
        pcs: localStorage.getItem('pcs'),
      },
    })
    .then(response => {
      commit('SET_NOTES_MODULE_DATA', response.data.settings)
    })
  },

  populateFromDB: async ({ commit, dispatch, state }, payload) => {
    if (payload) {
      commit('POPULATE_NOTES_FROM_DB', payload)
    } else {
      dispatch('populateNotesFromDB')
    }
  },
}

export const mutations = {
  SET_NOTES_MODULE_DATA(state, payload) {
    // populate from settings in database
  },
  SET_USER_MODULE_CONTENT(state, payload){
    // Set module content from user_has_module content
    state.text = payload.text ?? ''
  },
  UPDATE_NOTES: (state, payload) => {
    state.text = payload
  },

  POPULATE_NOTES_FROM_DB: (state, payload) => {
    state.text = payload.text
    
  },

  CLEAR_STATE: state => {
    state.text = ''
  },
}
